// components/ConditionalSelectSection.jsx
import React from "react";
import { Box, Typography, Select, MenuItem, FormControl } from "@mui/material";

const ConditionalSelectSection = ({
  title,
  value,
  onChange,
  conditionValue,
  children,
  selectProps = {},
  containerSx = {},
}) => {
  // Permite que conditionValue sea un string, número, o un array de valores permitidos
  const shouldRenderChildren = React.useMemo(() => {
    if (conditionValue === undefined || conditionValue === null) return false;
    if (Array.isArray(conditionValue)) return conditionValue.includes(value);
    return value === conditionValue;
  }, [value, conditionValue]);

  return (
    <Box sx={{ marginBottom: 2, ...containerSx }}>
      <FormControl variant="outlined" sx={{ width: "100%" }}>
        <Typography variant="subtitle1" gutterBottom>
          {title}
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Select
            value={value}
            onChange={onChange}
            sx={{ flexGrow: 1, width: "25%" }}
            {...selectProps}
          >
            {selectProps.options &&
              selectProps.options.map((opt) => (
                <MenuItem key={opt} value={opt}>
                  {opt}
                </MenuItem>
              ))}
          </Select>
          {shouldRenderChildren && children}
        </Box>
      </FormControl>
    </Box>
  );
};

export default ConditionalSelectSection;
